export class TranslationEntity {
  id: number;
  language: string;
  subLanguage: string;
  word: string;
  translation: string;

  examId: number;
}
